import { Component, OnInit, Injector, Input, Output, EventEmitter } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';
import { ShowAddToBasketModal } from '../modals/addsymbolstobasket/show-add-symbols-to-basket-modal';

@Component({
  selector: 'app-mobile-basket-selector',
  template: require('./mobile-basket-selector.component.html'),
  styles: [require('./mobile-basket-selector.component.scss')]
})
export class MobileBasketSelectorComponent extends AppComponentBase implements  OnInit {

  constructor( injector: Injector) {
    super(injector);
   }

  ngOnInit() {
  }

  @Output('setNewBasket')
  change: EventEmitter<boolean> = new EventEmitter<boolean>();



  @Input() updateBasketEditView:boolean = false;

  get basketList() {
     return this.workspace.mobileBasketList;
   }


   get activeBasketObj()
   {
     return this.basketList.filter(v=>{
       if(v.id == String(this.activeBasket))
       {
          return v
       }
     })[0];
   }

   public updateBasketView(e:any)
   {

   }


  public toggleActiveBasket(v: number) {
    this.activeBasket = this.activeBasket == v ? -1 : v;
  }

  public get activeBasket() {
   return this.workspace.activeBasket;
  }

  public set activeBasket(id: number) {



    this.workspace.activeBasket = id;
    this.increment();
  //   if(this.updateBasketEditView)
  //   {
  //    this.modalService.dismissAll();
  //    this.showAddSymbolsToBasketModal();
  //  // this.symbols
  //   }


    
  }

  increment() {
    this.change.emit(true);
}

  private _showSubmenu: boolean = false;
  public get showSubmenu (): boolean {
    return this._showSubmenu;
  }
  public set showSubmenu ( value: boolean ) {
    this._showSubmenu = value;
  }
  




}
